export const DIALOGS = {
  VALIDATION: 'judgementAddValidation',
  REFUSAL: 'judgementAddrefusal',
  FEE_NOTE: 'judgementAddFeeNote',
} as const;

export const DIALOGS_STATE = {
  [DIALOGS.VALIDATION]: false,
  [DIALOGS.REFUSAL]: false,
  [DIALOGS.FEE_NOTE]: false,
};

export const DRAWERS = {
  PROCEDURE_INFORMATION: 'procedureInformation',
  CIVIL_PARTY: 'civilParty',
  JUDGEMENT_ADD: 'judgementAdd',
} as const;

export const DRAWERS_STATE = {
  [DRAWERS.PROCEDURE_INFORMATION]: false,
  [DRAWERS.CIVIL_PARTY]: false,
  [DRAWERS.JUDGEMENT_ADD]: false,
};

export const CURRENT_INDEX_STATE = {
  [DRAWERS.PROCEDURE_INFORMATION]: 0,
  [DRAWERS.CIVIL_PARTY]: 0,
  [DRAWERS.JUDGEMENT_ADD]: 0,
};
export const rcCoporeal = 'RC - Dommages corporels causés aux tiers';

export const INCOME_CERTIFICATE_DIALOG = {
  VALIDATION: 'incomeCertificateValidation',
  REFUSAL: 'incomeCertificateRefusal',
} as const;
